import { render, staticRenderFns } from "./WhatsappPhonePreview.vue?vue&type=template&id=c343cbd6&scoped=true&"
import script from "./WhatsappPhonePreview.vue?vue&type=script&lang=js&"
export * from "./WhatsappPhonePreview.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappPhonePreview.vue?vue&type=style&index=0&id=c343cbd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c343cbd6",
  null
  
)

export default component.exports